/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorklistsRouteImport } from './routes/worklists'
import { Route as TasksRouteImport } from './routes/tasks'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as DicomStoreRouteImport } from './routes/dicom-store'
import { Route as DestinationsRouteImport } from './routes/destinations'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as SettingsSettingKeyRouteImport } from './routes/settings/$settingKey'

const WorklistsRoute = WorklistsRouteImport.update({
  id: '/worklists',
  path: '/worklists',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksRoute = TasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const DicomStoreRoute = DicomStoreRouteImport.update({
  id: '/dicom-store',
  path: '/dicom-store',
  getParentRoute: () => rootRouteImport,
} as any)
const DestinationsRoute = DestinationsRouteImport.update({
  id: '/destinations',
  path: '/destinations',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsSettingKeyRoute = SettingsSettingKeyRouteImport.update({
  id: '/$settingKey',
  path: '/$settingKey',
  getParentRoute: () => SettingsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/destinations': typeof DestinationsRoute
  '/dicom-store': typeof DicomStoreRoute
  '/settings': typeof SettingsRouteWithChildren
  '/tasks': typeof TasksRoute
  '/worklists': typeof WorklistsRoute
  '/settings/$settingKey': typeof SettingsSettingKeyRoute
  '/settings/': typeof SettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/destinations': typeof DestinationsRoute
  '/dicom-store': typeof DicomStoreRoute
  '/tasks': typeof TasksRoute
  '/worklists': typeof WorklistsRoute
  '/settings/$settingKey': typeof SettingsSettingKeyRoute
  '/settings': typeof SettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/destinations': typeof DestinationsRoute
  '/dicom-store': typeof DicomStoreRoute
  '/settings': typeof SettingsRouteWithChildren
  '/tasks': typeof TasksRoute
  '/worklists': typeof WorklistsRoute
  '/settings/$settingKey': typeof SettingsSettingKeyRoute
  '/settings/': typeof SettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/destinations'
    | '/dicom-store'
    | '/settings'
    | '/tasks'
    | '/worklists'
    | '/settings/$settingKey'
    | '/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/destinations'
    | '/dicom-store'
    | '/tasks'
    | '/worklists'
    | '/settings/$settingKey'
    | '/settings'
  id:
    | '__root__'
    | '/'
    | '/destinations'
    | '/dicom-store'
    | '/settings'
    | '/tasks'
    | '/worklists'
    | '/settings/$settingKey'
    | '/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DestinationsRoute: typeof DestinationsRoute
  DicomStoreRoute: typeof DicomStoreRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  TasksRoute: typeof TasksRoute
  WorklistsRoute: typeof WorklistsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/worklists': {
      id: '/worklists'
      path: '/worklists'
      fullPath: '/worklists'
      preLoaderRoute: typeof WorklistsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks': {
      id: '/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof TasksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dicom-store': {
      id: '/dicom-store'
      path: '/dicom-store'
      fullPath: '/dicom-store'
      preLoaderRoute: typeof DicomStoreRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/destinations': {
      id: '/destinations'
      path: '/destinations'
      fullPath: '/destinations'
      preLoaderRoute: typeof DestinationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/$settingKey': {
      id: '/settings/$settingKey'
      path: '/$settingKey'
      fullPath: '/settings/$settingKey'
      preLoaderRoute: typeof SettingsSettingKeyRouteImport
      parentRoute: typeof SettingsRoute
    }
  }
}

interface SettingsRouteChildren {
  SettingsSettingKeyRoute: typeof SettingsSettingKeyRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsSettingKeyRoute: SettingsSettingKeyRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DestinationsRoute: DestinationsRoute,
  DicomStoreRoute: DicomStoreRoute,
  SettingsRoute: SettingsRouteWithChildren,
  TasksRoute: TasksRoute,
  WorklistsRoute: WorklistsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
